import { LabelProps, Label } from './Label';
export function LabelBodySmall(props: LabelProps) {
    return <Label variant="text-body-sm" {...props} />;
}
